import AddNotificationSettingForm from './AddNotificationSettingForm';

export default AddNotificationSettingForm;
